import React from "react";
import { Col, Row } from "react-styled-flexboxgrid";
import styled from "styled-components";
import { Title } from "./ui/Title";
import { Paragraph } from "./ui/Paragraph";
import { mediaQuery } from "react-styled-mediaquery";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { ArrowLink } from "./ui/ArrowLink";
import { Link } from "react-scroll";
import { colors } from "../lib/constant";
import imgMore from "../../assets/more.jpg";
import { FormattedMessage } from "react-intl";

export const SectionFeaturesAndMore = () => {
  return (
    <>
      <Row between="xs" middle="xs" id="sectionFeaturesAndMore">
        <Col xs={false} sm={5} md={5} lg={5}>
          <Img src={imgMore} alt="Image" effect="opacity" threshold={300} />
        </Col>

        <Col xs={12} sm={6} md={6} lg={6}>
          <TitleStyle htmlLevel={2} theme="titleBodyStyle">
            <FormattedMessage
              id="sectionFeatures.more.title"
              defaultMessage="And more ..."
            />
          </TitleStyle>
          <Paragraph>
            <FormattedMessage
              id="sectionFeatures.more.text"
              defaultMessage="Don’t stop being creative just yet. Flashix can add as many scanning process as your business requires... Let's talk about what you need to track & trace and Flashix will do it almost instantly !"
            />
          </Paragraph>
          <ArrowLink justifyContent="start" marginTop="25px">
            <DemoLink href="#" to="contact" smooth={true} duration={700}>
              <FormattedMessage
                id="button.label.contact_us"
                defaultMessage="Contact us"
              />
            </DemoLink>
          </ArrowLink>
        </Col>
      </Row>
    </>
  );
};

const TitleStyle = styled(Title)`
  line-height: 48px;

  ${mediaQuery("<=", "tablet")`
    line-height: 34px;
  `}
`;

const Img = styled(LazyLoadImage)`
  width: 100%;
  display: block;
`;

const DemoLink = styled(Link)`
  color: ${colors.primary};
`;
